export const limit = 250

export const snackbar = {
  displayTime: 4000,
  animationTime: 300
}

export const upload = {
  systemFiles: ['.DS_Store']
}

export const media = {
  file: {
    dimensions: {
      height: 205,
      width: 170,
      margin: {
        top: 7,
        right: 7,
        bottom: 7,
        left: 7
      }
    }
  },
  breadcrumb: {
    dimensions: {
      height: 20,
      width: 170,
      margin: {
        top: 15,
        right: 0,
        bottom: 5,
        left: 4
      }
    }
  }
}
export const treeDepth = 12
export const treeNodeHeight = 20
export const rootNodeMargin = 10

export const translation = {
  system: 'bms-client',
  namespaces: ['common', 'modules', 'user', 'bms']
}



// WEBPACK FOOTER //
// ./src/consts/index.js